/* Tile Touch — Shop by Range page.
   Groups products into ranges by "title minus colour minus size" so colourways collapse
   into one range while different formats of the same line stay together where the name
   matches (Hatsuborder, Hatsu Square, Bridges, Elementa, Dento…). One card per range;
   hovering flicks through the range's colourway photos; clicking expands the range inline. */
(function () {
  'use strict';
  var mount = document.querySelector('[data-range-grid]');
  if (!mount) return;

  var DATA_URL = '/collections/all-tiles?view=rangedata';
  var CACHE_KEY = 'tt_ranges_page_v2';
  var TTL = 12 * 3600 * 1000;

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function thumb(src, w) { return src ? src.replace(/(width=)\d+/, '$1' + w) + (src.indexOf('width=') === -1 ? (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : '') : ''; }
  function money(cents) {
    var v = (parseFloat(cents) || 0) / 100;
    var f = (window.theme && window.theme.moneyFormat) || '';
    if (!f || f.indexOf('{{') === -1) return '$' + v.toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }

  // Colour words (same vocabulary the swatches use) + noise words to strip for the range name.
  var COLOURS = ('white ivory cream beige sand green sage aqua blue teal mustard yellow terracotta red burgundy pink blush rose brown bronze grey gray charcoal black amber gold orange coral silver smoke rust saffron navy olive tan mint jade oribe avio natural pearl mocha taupe graphite ochre wheat espresso mahogany walnut slate army forest emerald khaki lime clay honey caramel oak ash bone linen cotto titanium ecru greige rosa avorio cenere verde terra speckle speckled dark light deep soft warm pale blood cocoa coffee almond ' +
    'sky duck egg dusty denim tarnished camel fern cloudy blanc blend sparkle alpi ambar evergreen artic pumice mid medium super plain').split(' ');
  var CSET = {}; COLOURS.forEach(function (w) { CSET[w] = 1; });

  function rangeOf(title) {
    var t = String(title || '')
      .replace(/\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?\s*(?:mm|cm)?\b/gi, ' ')
      .replace(/\d+(?:\.\d+)?\s*(?:mm|cm)\b/gi, ' ')
      .replace(/\bdiameter\b/gi, ' ');
    // split keeps alphanumerics so qualifiers like "3D" survive; pure numbers and
    // dimension leftovers ("82x", lone "x") are dropped, colours stripped
    var words = t.split(/[^A-Za-z0-9]+/).filter(Boolean);
    var kept = words.filter(function (w) {
      var lw = w.toLowerCase();
      if (/^\d+(?:\.\d+)?$/.test(w)) return false;
      if (/^\d+x$/i.test(w) || lw === 'x') return false;
      return !CSET[lw];
    });
    var name = kept.join(' ').replace(/\s+/g, ' ').trim();
    return name || (words[0] || 'Range');
  }
  function shortName(fullName) {
    // Display name: first ~3 meaningful words ("Hatsuborder Japanese Hand…" -> "Hatsuborder").
    // Connectors (di/de/della…) pull the following word in so "Ceppo Di Gre" survives intact.
    var words = fullName.split(' ');
    var generic = { japanese: 1, italian: 1, spanish: 1, hand: 1, crafted: 1, handcrafted: 1, glazed: 1, unglazed: 1, porcelain: 1, ceramic: 1, tile: 1, tiles: 1, mosaic: 1, mosaics: 1, full: 1, body: 1, matt: 1, gloss: 1, glossy: 1, look: 1, finish: 1 };
    var connector = { di: 1, de: 1, del: 1, della: 1, da: 1, la: 1, le: 1 };
    var out = [];
    for (var i = 0; i < words.length; i++) {
      var lw = words[i].toLowerCase();
      if (out.length && generic[lw]) break;
      out.push(words[i]);
      if (out.length >= 3 && !connector[lw]) break;
    }
    while (out.length > 1 && connector[out[out.length - 1].toLowerCase()]) out.pop();
    // distinctive qualifiers after the generic words ("… Tile 3D") define a sub-range —
    // append them so "Kent 3D" and "Kent" stay separate ranges
    words.forEach(function (w) { if (/\d/.test(w) && out.indexOf(w) === -1) out.push(w); });
    return out.join(' ');
  }

  function firstVal(v) { if (Array.isArray(v)) { for (var i = 0; i < v.length; i++) { var s = String(v[i]).trim(); if (s) return s; } return ''; } return v == null ? '' : String(v).trim(); }

  function fetchData() {
    return fetch(DATA_URL + '&page=1').then(function (r) { return r.json(); }).then(function (d) {
      var items = d.items || [], pages = d.pages || 1, reqs = [];
      for (var p = 2; p <= pages; p++) reqs.push(fetch(DATA_URL + '&page=' + p).then(function (r) { return r.json(); }).then(function (dd) { return dd.items || []; }).catch(function () { return []; }));
      return Promise.all(reqs).then(function (rest) { return items.concat.apply(items, rest); });
    });
  }
  function getItems() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && (Date.now() - c.t) < TTL && c.items) return Promise.resolve(c.items);
    } catch (e) {}
    return fetchData().then(function (items) {
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
      return items;
    });
  }

  function buildRanges(items) {
    // Group by the DISPLAY name, not the full stripped title — otherwise "Mosaic" vs
    // "Mosaics" vs "Kit Kat" wording splits one range into several identical cards.
    // known naming quirks in product titles that would otherwise split one range in two
    var ALIAS = { 'rimtou square': 'Rimtou' };
    var map = {};
    items.forEach(function (p) {
      var full = rangeOf(p.t);
      var name = shortName(full);
      if (ALIAS[name.toLowerCase()]) name = ALIAS[name.toLowerCase()];
      var key = name.toLowerCase();
      var r = (map[key] = map[key] || { key: key, name: name, fulls: {}, products: [] });
      r.fulls[full.toLowerCase()] = 1;
      r.products.push({
        handle: p.h, title: p.t || '', img: p.img || '', big: p.big || '', m2: p.m2 || 0, px: p.px || 0,
        size: firstVal(p.s), colour: firstVal(p.c).toLowerCase()
      });
    });
    var ranges = Object.keys(map).map(function (k) {
      var r = map[k];
      r.search = r.key + ' ' + Object.keys(r.fulls).join(' ');
      var sizes = {}; r.products.forEach(function (p) { if (p.size) sizes[p.size] = 1; });
      r.sizeCount = Object.keys(sizes).length || 1;
      var minM2 = 0; r.products.forEach(function (p) { if (p.m2 > 0 && (minM2 === 0 || p.m2 < minM2)) minM2 = p.m2; });
      r.minM2 = minM2;
      // one image per distinct colour so the hover flick walks the colour options,
      // not near-identical photos of the same colour in different sizes
      var seen = {}; r.imgs = [];
      r.products.forEach(function (p) {
        var ck = p.colour || p.handle, im = p.big || p.img;
        if (im && !seen[ck]) { seen[ck] = 1; r.imgs.push(im); }
      });
      r.colourCount = Object.keys(seen).length || r.products.length;
      return r;
    }).filter(function (r) { return r.products.length > 0; });
    // biggest ranges first, then alphabetical
    ranges.sort(function (a, b) { return (b.products.length - a.products.length) || a.name.localeCompare(b.name); });
    return ranges;
  }

  function cardHTML(r, i) {
    var img = r.imgs[0] ? thumb(r.imgs[0], 700) : '';
    return '<div class="rg-card" data-rg-card data-key="' + esc(r.key) + '" data-i="' + i + '" tabindex="0" role="button" aria-expanded="false" aria-label="' + esc(r.name) + ' range, ' + r.products.length + ' tiles">' +
      '<div class="rg-card__media">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(r.name) + ' range" loading="lazy" width="700" height="700">' : '<span class="rg-card__ph"></span>') +
        (r.colourCount > 1 ? '<span class="rg-card__flick" aria-hidden="true">' + r.colourCount + ' colours</span>' : '') +
      '</div>' +
      '<div class="rg-card__info">' +
        '<h3 class="rg-card__name">' + esc(r.name) + '</h3>' +
        '<p class="rg-card__meta">' + r.products.length + ' tile' + (r.products.length === 1 ? '' : 's') + (r.sizeCount > 1 ? ' · ' + r.sizeCount + ' sizes' : '') + (r.minM2 > 0 ? ' · from ' + money(r.minM2 * 100) + '/m²' : '') + '</p>' +
      '</div></div>';
  }

  function panelHTML(r) {
    var h = '<div class="rg-panel" data-rg-panel><div class="rg-panel__inner"><div class="rg-panel__head"><h4>' + esc(r.name) + ' — every tile in the range</h4><button type="button" class="rg-panel__close" data-rg-close aria-label="Close range">&times;</button></div><div class="rg-panel__grid">';
    r.products.forEach(function (p) {
      var im = (p.big || p.img) ? thumb(p.big || p.img, 500) : '';
      h += '<a class="rg-item" href="/products/' + esc(p.handle) + '">' +
        (im ? '<img src="' + esc(im) + '" alt="' + esc(p.title) + '" loading="lazy" width="500" height="500">' : '') +
        '<span class="rg-item__t">' + esc(p.title) + '</span>' +
        (p.m2 > 0 ? '<span class="rg-item__p">' + money(p.m2 * 100) + '/m² · ' + money(p.px) + ' per box</span>' : (p.px > 0 ? '<span class="rg-item__p">' + money(p.px) + '</span>' : '')) +
        '</a>';
    });
    return h + '</div></div></div>';
  }

  var RANGES = [];
  function render(filter) {
    var q = String(filter || '').toLowerCase().trim();
    var list = q ? RANGES.filter(function (r) { return r.search.indexOf(q) !== -1; }) : RANGES;
    var html = '';
    list.forEach(function (r) { html += cardHTML(r, RANGES.indexOf(r)); });
    mount.innerHTML = html || '<p class="text-muted">No ranges match "' + esc(q) + '".</p>';
    var count = document.querySelector('[data-rg-count]');
    if (count) count.textContent = list.length + ' range' + (list.length === 1 ? '' : 's');
  }

  // ---- hover flick-through ----
  var flick = { timer: null, card: null, idx: 0 };
  function startFlick(card) {
    var r = RANGES[parseInt(card.getAttribute('data-i'), 10)];
    if (!r || r.imgs.length < 2) return;
    stopFlick();
    flick.card = card; flick.idx = 0;
    var img = card.querySelector('img'); if (!img) return;
    flick.timer = setInterval(function () {
      flick.idx = (flick.idx + 1) % r.imgs.length;
      img.src = thumb(r.imgs[flick.idx], 700);
    }, 650);
  }
  function stopFlick() {
    if (flick.timer) clearInterval(flick.timer);
    if (flick.card) {
      var r = RANGES[parseInt(flick.card.getAttribute('data-i'), 10)];
      var img = flick.card.querySelector('img');
      if (r && img && r.imgs[0]) img.src = thumb(r.imgs[0], 700);
    }
    flick.timer = null; flick.card = null;
  }
  mount.addEventListener('mouseover', function (e) { var c = e.target.closest('[data-rg-card]'); if (c && c !== flick.card) startFlick(c); });
  mount.addEventListener('mouseout', function (e) { var c = e.target.closest('[data-rg-card]'); if (c && !c.contains(e.relatedTarget)) stopFlick(); });
  mount.addEventListener('focusin', function (e) { var c = e.target.closest('[data-rg-card]'); if (c) startFlick(c); });
  mount.addEventListener('focusout', function (e) { var c = e.target.closest('[data-rg-card]'); if (c && !c.contains(e.relatedTarget)) stopFlick(); });

  // ---- expand a range ----
  function closePanel() {
    var p = mount.querySelector('[data-rg-panel]'); if (p) p.remove();
    mount.querySelectorAll('[data-rg-card][aria-expanded="true"]').forEach(function (c) { c.setAttribute('aria-expanded', 'false'); c.classList.remove('is-open'); });
  }
  function openPanel(card) {
    var r = RANGES[parseInt(card.getAttribute('data-i'), 10)]; if (!r) return;
    closePanel();
    card.setAttribute('aria-expanded', 'true'); card.classList.add('is-open');
    card.insertAdjacentHTML('afterend', panelHTML(r));
    try { history.replaceState(null, '', '#range=' + encodeURIComponent(r.key)); } catch (e) {}
    var p = mount.querySelector('[data-rg-panel]');
    if (p) p.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  mount.addEventListener('click', function (e) {
    if (e.target.closest('[data-rg-close]')) { closePanel(); try { history.replaceState(null, '', location.pathname); } catch (err) {} return; }
    if (e.target.closest('a')) return; // product links navigate
    var card = e.target.closest('[data-rg-card]');
    if (!card) return;
    if (card.getAttribute('aria-expanded') === 'true') { closePanel(); } else { openPanel(card); }
  });
  mount.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest('[data-rg-card]'); if (!card) return;
    e.preventDefault();
    if (card.getAttribute('aria-expanded') === 'true') closePanel(); else openPanel(card);
  });

  var search = document.querySelector('[data-rg-search]');
  if (search) search.addEventListener('input', function () { closePanel(); render(search.value); });

  getItems().then(function (items) {
    RANGES = buildRanges(items);
    render('');
    // deep link
    var m = /range=([^&]+)/.exec(location.hash || '');
    if (m) {
      var key = decodeURIComponent(m[1]);
      var card = mount.querySelector('[data-rg-card][data-key="' + key.replace(/"/g, '') + '"]');
      if (card) { openPanel(card); card.scrollIntoView({ block: 'center' }); }
    }
  }).catch(function () {
    mount.innerHTML = '<p class="text-muted">Couldn’t load ranges — <a href="/collections/all-tiles">browse all tiles instead</a>.</p>';
  });
})();
